import React from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import classNames from "classnames";
import { twMerge } from "tailwind-merge";
import PaginationDropdown from "./PaginationDropdown";
import { Option, PaginationInfo } from "../../types";

interface PaginationProps {
  paginationInfo: PaginationInfo;
  setPage: (page: number) => void;
  setPerPage: (perPage: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  paginationInfo,
  setPage,
  setPerPage,
}) => {
  // declarations
  const rowOptions: Option[] = [
    {
      value: "5",
      label: "5",
    },
    {
      value: "10",
      label: "10",
    },
    {
      value: "20",
      label: "20",
    },
  ];

  const perPageOption = rowOptions.find(
    (option) => +option.value === paginationInfo.perPage
  );

  const numberOfPages = Math.ceil(
    paginationInfo.count / paginationInfo.perPage
  );

  // classes
  const iconsClasses = "text-gray-500 cursor-pointer hover:text-primary transition-colors";
  const leftArrowClasses = twMerge(
    classNames(iconsClasses, {
      "opacity-30 cursor-not-allowed hover:text-gray-500": paginationInfo.page <= 1,
    })
  );
  const rightArrowClasses = twMerge(
    classNames(iconsClasses, {
      "opacity-30 cursor-not-allowed hover:text-gray-500": paginationInfo.page >= numberOfPages,
    })
  );

  // event handlers
  const handlePerPageChange = (selectedPerPageOption: Option) => {
    setPerPage(+selectedPerPageOption.value);
  };

  const handleLeftPage = () => {
    if (paginationInfo.page > 1) setPage(paginationInfo.page - 1);
  };

  const handleRightPage = () => {
    if (paginationInfo.page < numberOfPages) setPage(paginationInfo.page + 1);
  };

  // renders
  return (
    <div className="w-full flex justify-end items-center gap-4 text-sm text-gray-600">
      <div className="flex items-center gap-2">
        <span>Lignes par page:</span>
        <PaginationDropdown
          value={perPageOption}
          options={rowOptions}
          onChange={handlePerPageChange}
          className={"border border-gray-300 rounded-md"}
        />
      </div>
      <div className="flex items-center gap-4">
        <span>
          Page {paginationInfo.page} sur {numberOfPages || 1}
        </span>
        <div className="flex gap-2">
          <button 
            className="p-1 rounded-full hover:bg-gray-100 disabled:opacity-50"
            disabled={paginationInfo.page <= 1}
            onClick={handleLeftPage}
          >
            <FaChevronLeft className={leftArrowClasses} />
          </button>
          <button 
            className="p-1 rounded-full hover:bg-gray-100 disabled:opacity-50"
            disabled={paginationInfo.page >= numberOfPages}
            onClick={handleRightPage}
          >
            <FaChevronRight className={rightArrowClasses} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
